const toNumber = (value, fallback = 0) => {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
};

const jsonObject = (value) => {
    if (!value) return null;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed)
            ? parsed
            : null;
    } catch {
        return null;
    }
};

const textValue = (value) => String(value || "").trim();
const firstText = (...values) => values.map(textValue).find(Boolean) || "";

export const templateFirmSettings = (settings = {}) => ({
    ...settings,
    legalName: settings.FIRM_LEGAL_NAME || "",
    alias: settings.FIRM_ALIAS || "",
    ein: settings.FIRM_EIN || "",
    initialFee: toNumber(settings.FIRM_INITIAL_FEE),
    checkFee: toNumber(settings.FIRM_CHECK_FEE),
    currency: settings.FIRM_CURRENCY || "",
    googleReviewUrl: settings.FIRM_REVIEW_GOOGLE_URL || "",
    signature: jsonObject(settings.FIRM_SIGNATURE),
});

export const firmSignatureRecipient = (settings = {}) => {
    const signature = settings.signature || jsonObject(settings.FIRM_SIGNATURE) || {};
    const name = firstText(signature.name, signature.displayName, signature.fullName);
    const email = firstText(signature.email, signature.emailAddress, signature.mail);

    if (!name || !email) return null;

    return {
        key: "firm",
        name,
        email,
        role: "firm",
        recipientType: "signer",
        type: "signer",
        isRequired: true,
        metadata: {
            source: "firm.signature",
        },
    };
};
